import { useFieldArray, useForm } from "react-hook-form";
import { CategoryModal } from "../CategoryGrid";
import * as React from "react";
import { flattenDimensionItems, renderDimensionFormCells } from "../Category/helpers";
import { useDimensionFiltering } from "../Category/useDimensionFiltering";
import { FormSelect, NumericFormInput } from "../../../../../../components/Forms";
import { nonNumericSymbols, VALIDATION_PATTERNS } from "../../../../../../utils";

// Seed measure ids ship with the platform (see 2023051501_measures.csv).
// 4 = CUBIC_METERS, 2 = LITRES.
export const WATER_MEASURE_OPTIONS = [
  { value: 4, label: "m³" },
  { value: 2, label: "Litres" }
];

const DEFAULT_MEASURE_ID = 4;

function WaterUsageModalWrapper({
  modalData,
  attributesOrder,
  isOpen,
  onClose,
  onSubmit,
  getEmptyRow
}) {
  const { fieldArrayName, editData, organizationStructure, dimensionItems } = modalData;

  const seededEditData = editData ? flattenDimensionItems(editData) : null;

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [seededEditData ? seededEditData : getEmptyRow()]
    }
  });

  const { fields, append, remove } = useFieldArray({ control, name: fieldArrayName });

  const watchFieldArray = watch(fieldArrayName);

  const { getFilteredItems, setChangedRowIndex } = useDimensionFiltering({
    dimensionItems,
    editData: seededEditData,
    watchFieldArray
  });

  const mapRow = (row, index) => {
    const gridItems = [];

    gridItems.push(...renderDimensionFormCells({
      organizationStructure,
      dimensionItems,
      register,
      fieldArrayName,
      index,
      watchFieldArray,
      getFilteredItems,
      onDimensionChange: setChangedRowIndex
    }));

    gridItems.push(
      <NumericFormInput
        errors={errors}
        {...register(`${fieldArrayName}.${index}.value`, {
          required: "Value is required",
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
        onKeyDown={(e) => nonNumericSymbols.includes(e.key) && e.preventDefault()}
        type="number"
        title={watchFieldArray[index]?.value}
      />
    );

    gridItems.push(
      <FormSelect
        errors={errors}
        {...register(`${fieldArrayName}.${index}.measureId`, {
          required: "Unit is required",
          valueAsNumber: true
        })}
        title={WATER_MEASURE_OPTIONS.find(o => Number(o.value) === Number(watchFieldArray[index]?.measureId))?.label}
      >
        {WATER_MEASURE_OPTIONS.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </FormSelect>
    );

    return gridItems;
  };

  return (
    <CategoryModal
      modalData={modalData}
      formData={{ handleSubmit, fields, append, remove }}
      attributesOrder={attributesOrder}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      getEmptyRow={getEmptyRow}
      mapRow={mapRow}
    />
  );
}

export { DEFAULT_MEASURE_ID };
export default WaterUsageModalWrapper;
